<template>
  <div class="headerinfo">
   <img class="logo1" :src="`${IP_TEST}/uploads/${logopic}`" width="568" height="115" alt="佰标技术服务网" />
   <h1>佰标技术服务网</h1>
   <h6>您好，欢迎您来到佰标技术服务网！</h6>
   <div class="info-seach">
     <el-autocomplete 
      class="inline-input" 
      v-model="inputinfo" 
      :fetch-suggestions="querySearch" 
      placeholder="请输入关键字"
      :trigger-on-focus="false" @select="handleSelect">
      </el-autocomplete>
      <button @click="handleSearch" class="seachbtn">搜索</button>
    </div>
  </div>
</template>

<script>
import { IP_TEST } from '@/config';

export default {
  name: "Header",
  data() {
    return {
      IP_TEST: IP_TEST,
      inputinfo: "",
      restaurants: [],
      queryInfo: null,
      list: [
        {
          id: "1",
          "value": "新闻动态",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "2",
          "value": "信息公开",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "3",
          "value": "技术服务",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "4",
          "value": "教育培训",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "5",
          "value": "标准培训",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "6",
          "value": "资讯动态",
          type: "view",
          path: '/news/views/'
        }
      ]
    }
  },
  computed: {
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
      };
    },
    loadAll() {
      let { plates } = this.$store.state;
      this.list = this.list.map((item) => {
        let plate = plates.find(plate => plate.name.replace("T", "") == item.value);
        plate && (item['uuid'] = plate.uuid);
        return item;
      });
      return this.list;
    },
    handleSelect(item) {
      this.queryInfo = item;
    },
    handleSearch() {
      if (this.queryInfo&&this.queryInfo.value == this.inputinfo) {
        this.$router.push('' + this.queryInfo.path + this.queryInfo.uuid);
      }
      if (this.inputinfo) {
        let result = this.list.filter(item => item.value == this.inputinfo)
        if (result.length === 0) {
          this.$router.push({
            path: '/news/views/search',
            query: {
              keyWords: this.inputinfo
            }
          });
        } else {
          this.$router.push('' + result[0].path + result[0].uuid);
        }
      }
    }
  },
  mounted() {
    this.restaurants = this.loadAll();
  }
};
</script>
<style scoped>
.headerinfo{
  position: relative;
  width: 1200px;
  height: 210px;
}
.headerinfo>.logo1,.headerinfo>.logo2{
  position: absolute;
}
.headerinfo>.logo1{
  top:61px;
  left: 1px;
}
.headerinfo>h1{
  position: absolute;
  left:-1116px;
}
.headerinfo>h6{
  position: absolute;
  top:67px;
  left:840px;
  width: 230px;
  height: 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.headerinfo>.info-seach {
  position: absolute;
  top: 106px;
  right: 1px;
  width: 349px;
  height: 46px;
  padding-left: 11px;
  background: #FFFFFF;
  border: 1px solid #2479D3;
  border-radius: 6px 6px 6px 6px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 46px;
  opacity: 0.92;
}

headerinfo>.info-seach {
  overflow: hidden;
  display: flex;
  justify-content: start;
  align-items: center;
}

.headerinfo>.info-seach /deep/ .inline-input {
  width: 279px;
  height: 46px;
  color: #999999;
}

.headerinfo>.info-seach /deep/ .inline-input>.el-input {
  border: 0;
  background-color: #FFFFFF;
}

.headerinfo>.info-seach /deep/ .inline-input>.el-input>.el-input__inner {
  border: 0;
  background-color: #FFFFFF;
  padding-left: 15px;
  font-size: 14px;
  height: 46px;
  line-height: 46px;
  font-family: PingFang SC;
  font-weight: 500;
}

.headerinfo>.info-seach>.seachbtn {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 62px;
  height: 48px;
  border-radius: 0px 6px 6px 0px;
  z-index: 1;
  background-color: #2479D3;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 48px;
}
</style>
